(function () {
  const input = document.getElementById('Search-In-Modal') ||
                document.querySelector('input[name="q"][type="search"]') ||
                document.querySelector('.search-modal__input');

  if (!input) return;

  const dropdown = document.createElement('div');
  dropdown.id = 'aamghar-search-suggestions';
  dropdown.style.cssText = `
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 8px 30px rgba(0,0,0,0.12);
    z-index: 9999;
    max-height: 420px;
    overflow-y: auto;
    display: none;
    margin-top: 6px;
  `;

  const parent = input.closest('form') || input.parentElement;
  parent.style.position = 'relative';
  parent.appendChild(dropdown);

  let debounceTimer;

  input.addEventListener('input', function () {
    clearTimeout(debounceTimer);
    const query = this.value.trim();
    if (query.length < 2) {
      dropdown.style.display = 'none';
      dropdown.innerHTML = '';
      return;
    }
    debounceTimer = setTimeout(() => fetchSuggestions(query), 250);
  });

  document.addEventListener('click', function (e) {
    if (!parent.contains(e.target)) {
      dropdown.style.display = 'none';
    }
  });

  function fetchSuggestions(query) {
    fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6`)
      .then(res => res.json())
      .then(data => {
        const products = data.resources.results.products || [];
        renderResults(products, query);
      })
      .catch(() => { dropdown.style.display = 'none'; });
  }

  // Format price — Shopify suggest API returns price as a string like "91.00"
  function formatPrice(p) {
    const num = parseFloat(p);
    return '₹' + num.toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  }

  function renderResults(products, query) {
    dropdown.innerHTML = '';

    if (products.length === 0) {
      dropdown.innerHTML = `<div style="padding:16px;text-align:center;color:#888;font-size:13px;">No products found for "<strong>${escapeHtml(query)}</strong>"</div>`;
      dropdown.style.display = 'block';
      return;
    }

    const header = document.createElement('div');
    header.style.cssText = 'padding:10px 16px 6px;font-size:11px;font-weight:700;color:#aaa;text-transform:uppercase;letter-spacing:0.8px;';
    header.textContent = 'Products';
    dropdown.appendChild(header);

    products.forEach(product => {
      const item = document.createElement('a');
      item.href = product.url;
      item.style.cssText = `display:flex;align-items:center;gap:12px;padding:10px 16px;text-decoration:none;color:#1a1a1a;transition:background 0.15s;border-top:1px solid #f2f2f2;`;

      item.addEventListener('mouseenter', () => item.style.background = '#fafafa');
      item.addEventListener('mouseleave', () => item.style.background = 'transparent');

      const imgUrl = product.featured_image && product.featured_image.url;
      const img = imgUrl
        ? `<img src="${imgUrl}&width=80" alt="${escapeHtml(product.title)}" style="width:48px;height:48px;object-fit:cover;border-radius:8px;flex-shrink:0;">`
        : `<div style="width:48px;height:48px;background:#f2f2f2;border-radius:8px;flex-shrink:0;"></div>`;

      const priceHtml = product.price
        ? `<span style="font-size:13px;font-weight:700;color:#1a1a1a;">${formatPrice(product.price)}</span>`
        : '';

      const comparePriceHtml = (product.compare_at_price_min && parseFloat(product.compare_at_price_min) > parseFloat(product.price))
        ? `<span style="font-size:11px;color:#aaa;text-decoration:line-through;margin-left:5px;">${formatPrice(product.compare_at_price_min)}</span>`
        : '';

      item.innerHTML = `
        ${img}
        <div style="flex:1;min-width:0;">
          <div style="font-size:13px;font-weight:600;line-height:1.3;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">${escapeHtml(product.title)}</div>
          <div style="margin-top:3px;">${priceHtml}${comparePriceHtml}</div>
        </div>
        <svg width="16" height="16" fill="none" stroke="#ccc" stroke-width="2" viewBox="0 0 24 24"><path d="M9 18l6-6-6-6"/></svg>
      `;

      dropdown.appendChild(item);
    });

    const viewAll = document.createElement('a');
    viewAll.href = `/search?q=${encodeURIComponent(query)}&type=product`;
    viewAll.style.cssText = `display:block;text-align:center;padding:12px;font-size:13px;font-weight:600;color:#cc1f2e;text-decoration:none;border-top:1px solid #f2f2f2;`;
    viewAll.textContent = `View all results for "${query}"`;
    dropdown.appendChild(viewAll);

    dropdown.style.display = 'block';
  }

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, m => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[m]));
  }
})();